<template>
<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-12">
                <h4 class="card-title">Vendor Overview</h4>
            </div>
            <div class="col-xl-12" v-if="!loading">
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <span class="nav-link" v-bind:class="{active: showActive}" @click="showActives">Active Contracts ({{Object.keys(vendors_list.active).length}})</span>
                    </li>
                    <li class="nav-item">
                        <span class="nav-link" v-bind:class="{active: showExpired}" @click="showExpireds">Expired Contracts ({{Object.keys(vendors_list.expired).length}})</span>
                    </li>
                    <li class="nav-item">
                        <span class="nav-link" v-bind:class="{active: showIncoming}" @click="showIncomings">Incoming Renewals ({{Object.keys(vendors_list.incoming).length}})</span>
                    </li>
                    <li class="nav-item">
                        <span class="nav-link" v-bind:class="{active: showInProgress}" @click="showInProgresses">Open Renewals ({{Object.keys(vendors_list.in_progress).length}})</span>
                    </li>
                </ul>
                <div class="active-contracts" v-if="showActive && Object.keys(vendors_list.active).length>0">
                    <enhanced-table id='active' :hideFields="['contract_number']" :datalist="vendors_list_linked.active" />
                </div>
                <div class="expired-contracts" v-if="showExpired && Object.keys(vendors_list.expired).length>0">
                    <enhanced-table id='expired' :hideFields="['contract_number']" :datalist="vendors_list_linked.expired" />
                </div>
                <div class="incoming-renewals" v-if="showIncoming  && Object.keys(vendors_list.incoming).length>0">
                    <enhanced-table id='incoming' :hideFields="['contract_number']" :datalist="vendors_list_linked.incoming" />
                </div>
                <div class="inprogress-contracts" v-if="showInProgress && Object.keys(vendors_list.in_progress).length>0">
                    <enhanced-table id='inprogress' :hideFields="['contract_number']" :datalist="vendors_list_linked.in_progress" />
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ChartCard from 'src/components/Cards/ChartCard.vue'
import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table.vue'
import axios from 'axios'
import {
    colors,
    formatMoney,
    formatSimple
} from 'src/globalVariables'
import {
    setInterval
} from 'timers';

Number.prototype.pad = function (size) {
    let s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}

export default {
    components: {
        LTable,
        ChartCard,
        StatsCard
    },
    async created() {
        try {
            this.accessToken = await this.$auth.getAccessToken()
            this.loadData();
            let vm = this;
            setInterval(function () {
                vm.loadData();
            }, vm.refresh_minutes * 60 * 1000);

        } catch (e) {
            console.error(e)
            this.failed = true
        }
    },
    watch: {
        vendors_list: function () {
            this.vendors_list_linked = this.vendors_list;

            for (let status in this.vendors_list_linked) {
				this.vendors_list_linked[status].forEach(function (v) {
					v['link'] = {
						'url': 'vendor/' + v['contract_number'],
						'text': 'details'
					}
				})
			}
        }
    },
    methods: {
        loadData() {
            let today = new Date();
            this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2);
            axios
                .get('vendors/list?access_token=' + this.accessToken, {})
                .then(response => (
                    this.vendors_list = response.data.results,
                    this.loading = false
                ));
        },
        showActives() {
            this.showActive = true;
            this.showExpired = false;
            this.showIncoming = false;
            this.showInProgress = false;
        },
        showExpireds() {
            this.showActive = false;
            this.showExpired = true;
            this.showIncoming = false;
            this.showInProgress = false;
        },
        showIncomings() {
            this.showActive = false;
            this.showExpired = false;
            this.showIncoming = true;
            this.showInProgress = false;
        },
        showInProgresses() {
            this.showActive = false;
            this.showExpired = false;
            this.showIncoming = false;
            this.showInProgress = true;
        }
    },
    data() {
        return {
            accessToken: null,
            refresh_minutes: 30,
            last_update: '',
            colors: colors,
            vendors_list: [],
            vendors_list_data: {},
            vendors_list_linked: {},
            editTooltip: 'Edit Task',
            deleteTooltip: 'Remove',
            showExpired: false,
            showActive: true,
            showIncoming: false,
            showInprogress: false,
            loading: true,
        }
    }
}
</script>

<style>
h4.btn {
    background-color: #343a40;
    border-color: #343a40;
    color: #FFFFFF;
}

span.nav-link {
    cursor: pointer;
}
</style>
